import { DataLayer, calcPrice } from '@grandvisionhq/analytics';
import { Locales } from '@grandvisionhq/state';
import { mapProductToDataLayerProductObject } from './Mappers/ProductMapper.js';

const pushPdpEventToDataLayer = (purchaseType, product, activeSku, currency, productType, pricePerMonth)=>{
    pushEventToDataLayer(purchaseType, product, activeSku, currency, {
        list: 'pdp'
    }, 'gvProductDetail', productType, pricePerMonth);
};
const pushEventToDataLayer = (purchaseType, product, activeSku, currency, actionField, dataEvent, productType, pricePerMonth, eventType, offering)=>{
    const productObject = mapProductToDataLayerProductObject(purchaseType, product, activeSku, // Data in the Data Layer should always be English, therefore hardcoded locale
    Locales['en-GB'], productType, pricePerMonth, offering);
    if (!productObject) {
        return;
    }
    DataLayer.pushEcommerceEvent({
        event: dataEvent,
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                [eventType || 'detail']: {
                    actionField,
                    products: [
                        productObject
                    ]
                }
            }
        }
    });
};
const pushTabClickEvent = (isCLBBTabSelected)=>{
    DataLayer.pushEvent({
        event: 'ContactLensesConfigEvent',
        eventAction: 'click on tab',
        eventLabel: isCLBBTabSelected ? DataLayer.DataLayerTypes.PurchaseType.CLBBSubscription : DataLayer.DataLayerTypes.PurchaseType.OneTime
    });
};
const pushQuantityDiscountSelectionEvent = (sku, name, price, discountedPrice, discountPercentage)=>{
    DataLayer.pushEvent({
        event: 'select_quantity_discount',
        ecommerce: {
            promotion_name: 'quantity discount',
            discount_percentage: discountPercentage,
            items: [
                {
                    item_id: sku,
                    item_name: name,
                    price: calcPrice(price),
                    discount: calcPrice(discountedPrice)
                }, 
            ]
        }
    });
};
const pushAddFromMiniCartEvent = (sku, name, brand, category, price, discountedPrice, cartId)=>{
    DataLayer.pushEvent({
        event: 'mini_cart_click',
        site_feature: 'mini_cart',
        interaction_type: 'add_to_cart_click',
        items: [
            {
                item_id: sku,
                item_name: name,
                item_brand: brand,
                item_category: category,
                price: calcPrice(discountedPrice),
                metric140: calcPrice(price),
                cart_id: cartId !== null && cartId !== void 0 ? cartId : ''
            }, 
        ]
    });
};

export { pushAddFromMiniCartEvent, pushEventToDataLayer, pushPdpEventToDataLayer, pushQuantityDiscountSelectionEvent, pushTabClickEvent };
//# sourceMappingURL=data-layer.js.map
